import * as React from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { useSnackbar } from "notistack";

import Moment from "react-moment";
import moment from "moment";

import Countdown from "react-countdown";

import {
  makeStyles,
  withStyles,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Grid,
  Paper,
  Button,
  InputBase,
  Fab,
} from "@material-ui/core";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import WarningIcon from "@material-ui/icons/Warning";
import * as COLORS from "@material-ui/core/colors";

import "./Invest.scss";
import LoadingButton from "../Components/LoadingButton";

import useIcon from "../hooks/useIcon";
import {
  exitInvest,
  getCalculateReward,
  harvestToken,
} from "./InvestFunctions";
import HarvestAcceptDialog from "./HarvestAcceptDialog";
import WithdrawAcceptDialog from "./WithdrawAcceptDialog";

const useStyles = makeStyles((theme) => ({
  primaryText: {
    fill: theme.palette.primary.main,
    color: theme.palette.primary.main,
  },

  calcIcon: {
    fill: COLORS.grey[500],
    "&:hover": {
      fill: COLORS.grey[400],
    },
  },

  hoverColor: {
    "&:hover": {
      fill: COLORS.grey[500],
      color: COLORS.grey[500],
    },
  },

  textDecorate: {
    textDecorationLine: "underline",
    textDecorationThickness: "initial",
    textDecorationStyle: "dotted",
    textUnderlineOffset: "0.1em",
  },

  infoBox: {
    borderRadius: "14px",
    border: `1px solid ${COLORS.grey[300]}`,
    height: "100%",
    padding: theme.spacing(2),
  },

  infoBoxTitle: {
    textTransform: "uppercase",
    fontWeight: 500,
    lineHeight: 1,
    color: COLORS.grey[500],
    marginBottom: theme.spacing(1),
    display: "flex",
    alignItems: "center",
  },

  infoBoxBTN: {
    boxShadow: "none",
    borderRadius: "14px",
    minWidth: "max-content",
  },

  infoBoxCaption: {
    color: COLORS.grey[500],
  },

  infoLoadingBTNBox: {
    margin: "0px -8px",
  },

  warningBtn: {
    backgroundColor: "#ffc107",
    "&:hover": {
      backgroundColor: "#e5ad04",
    },
  },

  infoBoxLink: {
    color: `${theme.palette.primary.main} !important`,
    textDecoration: "none",
    display: "flex",
    alignItems: "center",
    "&:hover": {
      textDecoration: "underline",
    },
  },
  infoBoxRefreshIcon: {
    fill: `${theme.palette.primary.main}`,
    marginLeft: theme.spacing(1),
    cursor: "pointer",
  },
  grid: {
    display: "flex",
    flexFlow: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },
  input: {
    ...theme.typography.h5,
    width: "100%",
  },
  coinImage: {
    width: "20px",
    marginRight: theme.spacing(1),
  },
  fab_max: {
    minWidth: "initial",
    height: "initial",
    fontSize: "10px",
    padding: "0px 4px",
    marginLeft: theme.spacing(0.5),
    boxShadow: "none",
    borderRadius: theme.spacing(1),
  },
  buttonIcon: {
    marginRight: theme.spacing(1),
    padding: theme.spacing(0.4),
  },
  timer: {
    minWidth: "max-content",
    margin: "0px",
  },
}));

const MuiAccordion = withStyles({
  root: {
    border: "1px solid rgba(0, 0, 0, .125)",
    boxShadow: "none",
    "&:not(:last-child)": {
      borderBottom: 0,
    },
    "&:before": {
      display: "none",
    },
    "&$expanded": {
      width: "100%",
      margin: "auto",
    },
  },
  expanded: {},
})(Accordion);

const MuiAccordionSummary = withStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.default,
    borderBottom: "1px solid rgba(0, 0, 0, .125)",
    marginBottom: -1,
    minHeight: 56,
    "&$expanded": {
      minHeight: 56,
    },
  },
  content: {
    "&$expanded": {
      margin: "12px 0",
    },
  },
  expanded: {},
}))(AccordionSummary);

const MuiAccordionDetails = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(AccordionDetails);

function InvestListView({
  item,
  network,
  selectedContract,
  active,
  handleChange,
  refreshData,
}) {
  const [iconImage] = useIcon();
  const { enqueueSnackbar } = useSnackbar();
  const classes = useStyles();

  const [reward, setReward] = React.useState(0);

  const [showHarvestTimer, setShowHarvestTimer] = React.useState(true);
  const [showWithdrawTimer, setShowWithdrawTimer] = React.useState(true);

  const [harvestDialogOpen, setHarvestDialogOpen] = React.useState(false);
  const [withdrawDialogOpen, setWithdrawDialogOpen] = React.useState(false);

  const [loading, setLoading] = React.useState({
    withdraw: false,
    harvest: false,
  });

  const convertAmount = (amount, decimals) => {
    return amount / Number(`1e${decimals}`);
  };

  // Determines whether the button should be enabled or not
  const isHarvestButtonEnabled = () => {
    if (!+reward) {
      return false;
    } else {
      const currentTimeStamp = moment.utc().unix();
      const lastReward = item.lastRewardTime;
      let delay = selectedContract.withdrawDelay;

      return lastReward + delay < currentTimeStamp;
    }
  };

  const earlyWithdraw = () => {
    const currentTimeStamp = moment.utc().unix();

    let delay = selectedContract.minimumInvestmentPeriod;
    let investTime = item.startTime;

    return investTime + delay > currentTimeStamp;
  };

  const havestTimer = () => {
    const lastReward = item.lastRewardTime * 1000;
    let delay = selectedContract.withdrawDelay * 1000;

    return lastReward + delay;
  };

  const withdrawTimer = () => {
    let delay = selectedContract.minimumInvestmentPeriod * 1000;
    let investTime = item.startTime * 1000;

    return investTime + delay;
  };

  const getReward = () => {
    getCalculateReward(
      item.id,
      network.account,
      selectedContract.contractAddress
    ).then((res) => {
      setReward(res);
    });
  };

  const harvest = () => {
    setHarvestDialogOpen(false);
    setWithdrawDialogOpen(false);
    console.log("Attempting to token Harvest...");
    let loadings = { ...loading };
    loadings.harvest = true;
    setLoading(loadings);

    harvestToken(network.account, selectedContract.contractAddress, item.id)
      .then(() => {
        let loadings = { ...loading };
        loadings.harvest = false;
        setLoading(loadings);

        enqueueSnackbar("Harvest Successful", {
          variant: "success",
          autoHideDuration: 5000,
        });

        setReward(0);
      })
      .catch((e) => {
        let loadings = { ...loading };
        loadings.harvest = false;
        setLoading(loadings);
        enqueueSnackbar("Harvest Failed (" + e.reason + ")", {
          variant: "error",
          autoHideDuration: 5000,
        });
      });
  };

  const checkWithdrawAccess = () => {
    if (earlyWithdraw()) {
      if (!selectedContract.can_early_withdraw) {
        notAccessWithdrawFunction()
      } else {
        withdraw()
      }
    } else {
      withdraw();
    }
  };

  const notAccessWithdrawFunction = () => {
    setWithdrawDialogOpen(false);
    let loadings = { ...loading };
    loadings.withdraw = true;
    setLoading(loadings);

    setTimeout(() => {
      enqueueSnackbar("System error, please try again in a few minutes.", {
        variant: "error",
        autoHideDuration: 5000,
      });

      let loadings = { ...loading };
      loadings.withdraw = false;
      setLoading(loadings);
    }, 3000);
  };

  const withdraw = () => {
    setWithdrawDialogOpen(false);
    console.log("Attempting to token Withdraw...");
    let loadings = { ...loading };
    loadings.withdraw = true;
    setLoading(loadings);

    exitInvest(network.account, selectedContract.contractAddress, item.id)
      .then(() => {
        let loadings = { ...loading };
        loadings.withdraw = false;
        setLoading(loadings);

        enqueueSnackbar("Withdraw Successful", {
          variant: "success",
          autoHideDuration: 5000,
        });

        setTimeout(() => {
          refreshData();
        }, 5000);
      })
      .catch((e) => {
        let loadings = { ...loading };
        loadings.withdraw = false;
        setLoading(loadings);
        enqueueSnackbar("Withdraw Failed (" + e.reason + ")", {
          variant: "error",
          autoHideDuration: 5000,
        });
      });
  };

  React.useEffect(() => {
    getReward();
    const rewardInterval = setInterval(() => {
      getReward();
    }, 10000);

    return () => clearTimeout(rewardInterval);
  }, []);

  return (
    <>
      <HarvestAcceptDialog
        open={harvestDialogOpen}
        onClose={() => setHarvestDialogOpen(false)}
        onAccept={() => harvest()}
        amount={convertAmount(reward, selectedContract.coinOut.decimals)}
        symbol={selectedContract.coinOut.abbr}
      />

      <WithdrawAcceptDialog
        open={withdrawDialogOpen}
        onClose={() => setWithdrawDialogOpen(false)}
        onAccept={() => checkWithdrawAccess()}
        amount={convertAmount(item.amount, selectedContract.coinIn.decimals)}
        symbol={selectedContract.coinIn.abbr}
        investTime={item.startTime}
        delay={selectedContract.minimumInvestmentPeriod}
      />

      <MuiAccordion
        square
        expanded={active}
        onChange={handleChange(`panel${item.id}`)}
      >
        <MuiAccordionSummary
          aria-controls={`panel${item.id}`}
          id={`panel${item.id}d-header`}
        >
          <table className="w-100 invest-list">
            <tbody>
              <tr>
                <td className="name-icon">
                  <div className="d-flex align-items-center">
                    <img
                      src={iconImage(selectedContract.coinIn.abbr)}
                      alt={selectedContract.coinIn.abbr}
                    />

                    <Typography variant="body1" className="ms-2 fw-bold">
                      {selectedContract.coinIn.abbr}
                    </Typography>
                  </div>
                </td>
                <td className="invest">
                  <Typography variant="caption" className="lh-1">
                    Invest
                  </Typography>

                  <Typography variant="body1" className="lh-1 fw-bold">
                    {convertAmount(
                      item.amount,
                      selectedContract.coinIn.decimals
                    )}{" "}
                    {selectedContract.coinIn.abbr}
                  </Typography>
                </td>
                <td className="reward">
                  <Typography variant="caption" className="lh-1">
                    Reward
                  </Typography>
                  <Typography variant="body1" className="lh-1 fw-bold">
                    {convertAmount(reward, selectedContract.coinOut.decimals)}{" "}
                    {selectedContract.coinOut.abbr}
                  </Typography>
                </td>
                <td className="date">
                  <Typography variant="caption" className="lh-1">
                    Date
                  </Typography>
                  <Typography variant="body1" className="lh-1 fw-bold">
                    <Moment unix format="YYYY-MM-DD hh:mm">
                      {item.startTime}
                    </Moment>
                  </Typography>
                </td>
                <td className="detail">
                  <KeyboardArrowDownIcon className={classes.primaryText} />
                </td>
              </tr>
            </tbody>
          </table>
        </MuiAccordionSummary>
        <MuiAccordionDetails>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Paper elevation={0} className={classes.infoBox}>
                <Typography
                  variant="subtitle2"
                  className={classes.infoBoxTitle}
                >
                  <img
                    src={iconImage(selectedContract.coinOut.abbr)}
                    alt={selectedContract.coinOut.abbr}
                    className={classes.coinImage}
                  />
                  {selectedContract.coinOut.abbr} Reward
                </Typography>

                <Grid
                  container
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  className={classes.grid}
                >
                  {/* Text Field */}

                  <InputBase
                    disabled={true}
                    value={convertAmount(
                      reward,
                      selectedContract.coinOut.decimals
                    )}
                    placeholder="0.0"
                    classes={{
                      root: classes.input,
                      input: classes.inputBase,
                    }}
                  />

                  {/* Button */}

                  <div className={classes.infoLoadingBTNBox}>
                    <LoadingButton
                      loading={loading.harvest}
                      valid={isHarvestButtonEnabled()}
                      success={false}
                      fail={false}
                      onClick={() => setHarvestDialogOpen(true)}
                    >
                      Harvest
                    </LoadingButton>{" "}
                  </div>
                </Grid>
                {showHarvestTimer && (
                  <Typography variant="caption" className={classes.timer}>
                    <Countdown
                      date={havestTimer()}
                      onComplete={() => setShowHarvestTimer(false)}
                    />{" "}
                    To Harvest
                  </Typography>
                )}
              </Paper>
            </Grid>
            <Grid item xs={12} md={6}>
              <Paper elevation={0} className={classes.infoBox}>
                <Typography
                  variant="subtitle2"
                  className={classes.infoBoxTitle}
                >
                  <img
                    src={iconImage(selectedContract.coinIn.abbr)}
                    alt={selectedContract.coinIn.abbr}
                    className={classes.coinImage}
                  />
                  {selectedContract.coinIn.abbr} Invested
                </Typography>

                <Grid
                  container
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  className={classes.grid}
                >
                  {/* Text Field */}
                  <InputBase
                    disabled={true}
                    value={convertAmount(
                      item.amount,
                      selectedContract.coinIn.decimals
                    )}
                    placeholder="0.0"
                    classes={{
                      root: classes.input,
                      input: classes.inputBase,
                    }}
                  />

                  {/* Button */}

                  <div className={classes.infoLoadingBTNBox}>
                    <LoadingButton
                      className={earlyWithdraw() ? classes.warningBtn : ""}
                      loading={loading.withdraw}
                      valid={+item.amount > 0}
                      success={false}
                      fail={false}
                      onClick={() => setWithdrawDialogOpen(true)}
                    >
                      {earlyWithdraw() && (
                        <WarningIcon className={classes.buttonIcon} />
                      )}
                      {loading.withdraw
                        ? "processing"
                        : earlyWithdraw()
                        ? "early withdraw"
                        : "withdraw"}
                    </LoadingButton>{" "}
                  </div>
                </Grid>

                {showWithdrawTimer && (
                  <Typography variant="caption" className={classes.timer}>
                    <Countdown
                      date={withdrawTimer()}
                      onComplete={() => setShowWithdrawTimer(false)}
                    />{" "}
                    To Withdraw
                  </Typography>
                )}
              </Paper>
            </Grid>
          </Grid>
        </MuiAccordionDetails>
      </MuiAccordion>
    </>
  );
}

InvestListView.propTypes = {};

export default InvestListView;
